<template>
    <div id="app-container">
        <HeaderBar v-if="isLoggedIn && ! isLoginedNow"/>
        <Sidebar v-if="isLoggedIn && ! isLoginedNow"/>

        <div id="page-content-wrapper" v-if="isLoggedIn && ! isLoginedNow">
            <router-view />
        </div>

		<Auth v-if="! isLoggedIn || isLoginedNow" />

        <SideForm />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Sidebar from '@/new/views/Sidebar.vue'
import SideForm from '@/new/views/SideForm.vue'
import HeaderBar from '@/new/views/Mobile/HeaderBar.vue'
import Auth from '@/new/views/Auth.vue'

export default {
    components: {
        Sidebar,
        SideForm,
        HeaderBar,
        Auth
    },

    computed: {
        ...mapGetters(['isLoggedIn', 'isLoginedNow']),
    }
}
</script>

<style scoped lang="scss">

</style>